export const ROUTE_TITLES: Record<string, string> = {
  "bill": "Bill",
  "billing": "Billing",
  "dashboard": "DashBoard",
  "mastermodule": "Home",
  "mod0103": "Change Password",
  "mod0104": "Region",
  "mod0105": "Branch",
  "mod0106": "Enquiry",
  "mod0107": "Student",
  "mod0108": "Staff",
  "mod0109": "Course Category",
  "mod0110": "Course Master",
  "mod0111": "Curriculum",
  "mod0112": "Curriculum Details",
  "mod0113": "User Privilege",
  "mod0114": "Enquiry Receiver Mode",
  "mod0115": "Course Diary",
  "mod0116": "Edit Kyc",
  "mod0117": "Batch Master",
  "mod0118": "Privilege",
  "mod0119": "Profile",
  "mod0120": "Exam Batch Master",
  "mod0121": "Course Dairy",
  "mod0122": "Certification Generation",
  "mod0124": "Job Master",
  "mod0125": "Apply Jobs",
  "mod0126": "Pool Members",
  "mod0127": "Contact Report",
  "mod0128": "Jobs Report",
  "mod0129": "My Learning",
  "mod0130": "Course Diary",
  "mod0134": "My Courses",
  "mod0135": "Edit Certificate",
  "mod0136": "Fees Receipt Entry",
  "mod0137": "Online Exam",
  "mod0138": "Due Chart Entry",
  "mod0139": "Account Group",
  "mod0140": "Account Master",
  "mod0141": "Task Sheet",
  "mod0142": "Task Sheet Details",
  "mod0143": "Task Sheet Report",
  "mod0144": "Manual Attendance",
  "mod0145": "Staff Attendance Punch Report",
  "mod0146": "Course Diary",
  "mod0147": "Feedback Report",
  "mod0148": "Student Course Dairy Report",
  "mod0149": "Student Attendance Report",
  "mod0150": "Enquiry Followup Report",
  "mod0151": "Task Diary",
  "mod0152": "Batch Details Report",
  "mod0153": "Payment Process",
  "mod0154": "Admission Abstract Report",
  "mod0155": "Course Transfer",
  "mod0156": "Ledger Report",
  "mod0157": "Trial Balance",
  "mod0158": "Fees Structure",
  "mod0159": "Attendance Abstract",
  "mod0160": "Birthday Reminder",
  "mod0161": "Tree View",
  "mod0162": "Pending Report",
  "mod0163": "Admission Report",
  "mod0164": "Product Unit",
  "mod0165": "Product Group",
  "mod0166": "QR Scanner",
  "mod0167": "Brand Master",
  "mod0169": "Sales Invoice",
  "mod0170": "Purchase Invoice",
  "mod0171": "User Type",
  "mod0172": "Purchase Report",
  "mod0173": "Sales Report",
  "mod0175": "Reference Enquiry List",
  "mod0176": "Events",
  "mod0177": "Product Master",
  "mod0178": "Setup Transaction",
  "mod0179": "GST Filing Report",
  "mod0180": "Stock Report",
  "mod0181": "Setup Transaction",
  "/billing/mod0281": "Sales Return",
  "/accounts/mod0182": "Group Summary",
  "/accounts/mod0183": "Journal Entry",
  "/billing/mod0381": "Purchase Return",
  "mod0184": "Add Kyc",
  "mod0185": "Change Password",
  "mod0186": "E-Books Bundle",
  "mod0187": "Book Category",
  "mod0188": "E-Books",
  "mod0189": "Receipt Entry",
  "mod0190": "Debit Note",
  "mod0191": "Credit Note",
  "mod0201": "Admission",
  "mod0236": "Timesheet",
  "mod0239": "Leave / Permission Application",
  "mod0240": "Leave / Permission Process",
  "mod0241": "Leave Type",
  "mod0263": "Payment Approval",
  "mod0264": "Payment Request",
  "mod0265": "Billwise Outstanding",
  "mod0266": "Supplier",
  "mod0267": "Customer",
  "mod0268": "Contra",
  "mod0270": "Day Book",
  "mod0271": "Voucher Type",
  "mod0272": "Setup Transaction",
  "mod0273": "Tax Master / Configuration",
  "mod0274": "New Campaigns",
  "mod0275": "Campaigns",
  "mod0276": "Campaign Details",
  "mod0277": "Messages",
  "mod0278": "New Messages",
  "mod0279": "Company Master",
  "mod0301": "Question Bank",
  "mod0302": "Question Category",
  "mod0303": "Questions Difficulty",
  "mod0305": "Online Exam Portal",
  "mod0306": "Exams",
  "mod0307": "Question Type",
  "mod0308": "Exam Schedule",
  "mod0309": "Exam Assignment",
  "mod0310": "Exam Evaluation",
  "mod0311": "Exam Assessment",
  "mod0312": "My Exams",
  "mod0411": "User TimeSheet Bulk Assignment",
  "mod0412": "User TimeSheet Assignment",
  "mod0413": "Daily Attendance Process",
  "mod0414": "User Attendance Log",
  "mod0415": "Attendance Report",
  "mod0416": "Profit And Loss",
  "mod0417": "Balance Sheet",
  "mod0418": "Work Load",
  "mod0419": "License",
  "mod0420": "Update License",
  "mod0450": "Placement Support Registration",
  "mod0451": "Job Posts",
  "mod0452": "Job Portal",
  "mod0473": "Payment Entry",
  "mod0474": "Enquiry Analysis",
  "mod0475": "Feedback Analysis",
  "mod0476": "Notification Type",
  "mod0477": "Notification Broadcast",
  "mod0478": "Certificate Approval",
  "mod0479": "Delete Account",
  "mod0500": "Student Portal",
  "mod0501": "My Learning",
  "sin-bill-wgst": "Bill",
  "single-bill": "Bill",
};
